module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-map"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pt-2"
  }, [_c('button', {
    staticClass: "button info",
    on: {
      "click": _vm.showFilterPanel
    }
  }, [_vm._v("Show Filter Panel")])]), _c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
    ref: "map",
    attrs: {
      "searchBar": true,
      "api-key": _vm.mapsAPI,
      "center": _vm.mapCenter,
      "zoom": 13,
      "mapTypeId": 'roadmap',
      "scrollwheel": false,
      "zoomControl": true,
      "mapTypeControl": true
    },
    on: {
      "placesChanged": _vm.updateUserPosition
    }
  }, [(_vm.showfilter) ? _c('div', {
    staticClass: "toggles"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Filters")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.active_vehicle_slots),
      expression: "body.active_vehicle_slots"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "active_vehicle_slots", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Enabled")]), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Disabled")])]), _c('label', [_vm._v("Booking Mode")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reservation_type),
      expression: "body.reservation_type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "reservation_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._l((_vm.reservation_types), function(reservation_type, key) {
    return _c('option', {
      domProps: {
        "selected": _vm.value === key,
        "value": key
      }
    }, [_vm._v(_vm._s(reservation_type))])
  })], 2), _c('label', [_vm._v("Vehicle Type"), _c('selectize-vehicle-type', {
    on: {
      "optionSelected": _vm.optionSelected,
      "optionRemoved": _vm.optionRemoved
    }
  }), _c('ActionButton', {
    attrs: {
      "action": _vm.loadVehicles
    }
  }, [_vm._v("Apply filters")])], 1), _c('label', [_vm._v("License plate"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plate),
      expression: "plate"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.plate = $event.target.value
      }, _vm.filter]
    }
  })])]), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Zones")])]), _c('div', {
    staticClass: "button-group stacked small"
  }, [_c('button', {
    staticClass: "button secondary",
    class: {
      success: _vm.showAllowed
    },
    on: {
      "click": function($event) {
        _vm.showAllowed = !_vm.showAllowed
      }
    }
  }, [_vm._v("Allowed")]), _c('button', {
    staticClass: "button secondary",
    class: {
      warning: _vm.showUndesirable
    },
    on: {
      "click": function($event) {
        _vm.showUndesirable = !_vm.showUndesirable
      }
    }
  }, [_vm._v("Undesirable")]), _c('button', {
    staticClass: "button secondary",
    class: {
      alert: _vm.showForbidden
    },
    on: {
      "click": function($event) {
        _vm.showForbidden = !_vm.showForbidden
      }
    }
  }, [_vm._v("Forbidden")])])]) : _vm._e(), _vm._l((_vm.zones['allowed']), function(allowed) {
    return (_vm.showAllowed) ? _c('div', {
      staticClass: "allowed"
    }, _vm._l((allowed.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "green",
          "fillColor": "green"
        }
      })
    }), 1) : _vm._e()
  }), _vm._l((_vm.zones['forbidden']), function(forbidden) {
    return (_vm.showForbidden) ? _c('div', {
      staticClass: "forbidden"
    }, _vm._l((forbidden.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "red",
          "fillColor": "red"
        }
      })
    }), 1) : _vm._e()
  }), _vm._l((_vm.zones['undesirable']), function(undesirable) {
    return (_vm.showUndesirable) ? _c('div', {
      staticClass: "undesirable"
    }, _vm._l((undesirable.poly), function(poly) {
      return _c('google-map-polygon', {
        attrs: {
          "positions": poly,
          "color": "yellow",
          "fillColor": "yellow"
        }
      })
    }), 1) : _vm._e()
  }), _c('google-map-marker-cluster', _vm._l((_vm.filteredVehicles), function(vehicle) {
    return _c('google-map-marker', {
      key: vehicle.plate,
      attrs: {
        "icon": _vm.vehicleInRange(vehicle),
        "position": {
          lat: vehicle.position.latitude,
          lng: vehicle.position.longitude
        },
        "title": vehicle.model,
        "label": vehicle.model,
        "labelOrigin": [15, 30]
      },
      on: {
        "click": _vm.updateSelectedVehicle
      }
    }, [_c('vehicle', {
      attrs: {
        "item": vehicle,
        "type": 'fleet-map'
      }
    })], 1)
  }), 1)], 2) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20ce093b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/FleetMap.vue
// module id = 2199
// module chunks = 1